<template>
  <div class="inducteeListItem" @click.stop="$root.goto('InducteeDetailsPage', inductee.InducteeID)">
    <div class="left-item">
      <img class="inducteeImage" :src="'//classicalwalkoffame.org/inductees/' + inductee.ImageURL">
    </div>
    
    <div class="middle-item">
      <span class="name">{{ inductee.InducteeName }}</span><br>
      <span class="song">{{ inductee.MusicTitle }}</span><br>
    </div>
    
    <div class="right-item" @click.stop>
      <picker-modal
      @select="change"
      :options="['Fountain', 'Plaza', 'Device']">
        <sprite-button
        class='inducteeButton'
        width="56px"
        height="50px"
        background-url="img/play_button.png"
        ></sprite-button>
      </picker-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'inductee',
  ],
  methods: {
    change (value) {
      value = value.toLowerCase()
      console.log('value =', value)
      this.$root.queue({
        playlist: value,
        inductee: JSON.parse(JSON.stringify(this.inductee))
      })
    }
  }
}
</script>

<style lang="less">
.inducteeListItem {
  height: 65px;
  background: #10161d;
  margin-top: 3px;
  margin-bottom: 3px;
  padding-top: 15px;
  cursor: pointer;
  
  overflow: hidden;
  display: flex;
  flex-direction: row;
  .middle-item {
    flex: 1;
  }
  .right-item {
    position: relative;
  }
  img.inducteeImage {
    width: 60px;
    height: 60px;
    margin-top: -5px;
    margin-right: 15px;
    margin-left: 15px;
  }
  .name {
    color: #fff;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: bold;
    font-size: 16px;
  }
  .song {
    color: #afd2ef;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: normal;
    font-style: italic;
    font-size: 15px;
  }
}

</style>